export default import.meta.ROLLUP_FILE_URL_3Lrf7vA$GngskD3e2_Wsaw;